module.exports = __webpack_public_path__ + "static/carousel-10th-4e4a41bd2fb6eba4ed04869bb2266c8f.png";